import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import PageHeader from "../../components/common/PageHeader";
import Head from "./Head";  
import PaymentFailedModal from "./PaymentFailedModal";
import PaymentModal from "./PaymentModal";
import PaymentProcess from "./PaymentProcess";
import PaymentSuccessModal from "./PaymentSuccessModal";
import {
  payment,
  getPlans,
  update,
} from "./../../context/actions/subscription";
import { useHistory } from "react-router-dom";
import Plans from "./Plans";
import { useSelector } from "react-redux";
import { tempAction } from "../../context/actions/tempAction";
const Pricing = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const temporaryData = useSelector((state) => state?.tempReducer?.data);

  const [paymentProcess, setPaymentProcess] = useState(false);
  // state use to temp store all plans
  const [plans, setPlans] = useState("");
  // state use to subscription response
  const [subRes, setSubRes] = useState("");
  // state use to maintain payment modal open/close
  const [showModal, setShowModal] = useState(false);
  // state use to maintain success modal open/close
  const [isSuccess, setIsSuccess] = useState(false);
  // state use to maintain faile modal open/close
  const [isFaile, setIsFaile] = useState(false);
  // state use to stotre current plan
  const [choosePlan, setChoosePlan] = useState({});

  useEffect(() => {
    if (!plans) getCurrentPlan();
  });
  /**
   * @description method call to get all plans associative active plan
   */
  const getCurrentPlan = () => {
    dispatch(
      getPlans({ order: 1, sort: "price" }, (res) => {
        if (res) setPlans(res);
      })
    );
  };

  /**
   * @description metion use to make payment choose plan
   * @param {*} params encripted object card Info
   */
  const _handlePayment = (params) => {
    setPaymentProcess(true);
    let param = { ...params, plan_id: choosePlan._id };
    dispatch(
      payment(param, (res) => {
        setShowModal(false);
        setPaymentProcess(false);
        if (res) {
          setSubRes(res);
          getCurrentPlan();
          setIsSuccess(true);
        } else setIsFaile(true);
      })
    );
  };

  /**
   * @description metion use to make payment choose plan
   * @param {*} params encripted object card Info
   */
  const _handleUpgrade = (params) => {
    setPaymentProcess(true);
    let param = { ...params, plan_id: choosePlan._id };
    dispatch(
      update(param, plans?.currentSubscription?._id, (res) => {
        setShowModal(false);
        setPaymentProcess(false);
        if (res) {
          setSubRes(res);
          getCurrentPlan();
          setIsSuccess(true);
        } else setIsFaile(true);
      })
    );
  };

  const _submit = (params) => {
    if (plans?.currentSubscription) _handleUpgrade(params);
    else _handlePayment(params);
  };

  /**
   * @description method call to select current plan and open payment modal
   * @param {*} param selected plan
   */
  const _handlePlans = (param) => {
    setChoosePlan(param);
    setShowModal(true);
  };

  const _handleModalStatus = () => {
    setIsSuccess(false);
    setIsFaile(false);
  };

  return (
    <>
      <div className="page-wrapper">
        <PageHeader>Pricing</PageHeader>
        <div className="inner-wrapper">
          <div className="pricing-wrapper mx-auto">
            <Head />
            <Plans plans={plans?.docs} _handlePlans={_handlePlans} />
          </div>
        </div>
      </div>
      <PaymentModal
        _handlePayment={_submit}
        _showModal={showModal}
        _handleShowModal={() => {
          setShowModal(!showModal);
        }}
      />
      {isSuccess && (
        <PaymentSuccessModal
          _successRes={subRes}
          _modalStatus={isSuccess}
          _handleModalStatus={_handleModalStatus}
        />
      )}
      {isFaile && (
        <PaymentFailedModal
          _modalStatus={isFaile}
          _handleModalStatus={_handleModalStatus}
        />
      )}
      {paymentProcess && <PaymentProcess />}
    </>
  );
};
export default Pricing;
